import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const PaperDashboard = lazyLoader(
  () => import("Containers/Paper/PaperDashboard")
);

export const Papers = () => {
  return (
    <Layout>
      <PaperDashboard />
    </Layout>
  );
};
